import { isNil } from "lodash";
import { saveBlob } from "utils/helpers/files";
import { PDF_CONTENT_TYPE } from "../../constants";

let library = null;
let worker = null;

const pdfLibrary = () => {
  if (isNil(library))
    library = import("pdfjs-dist/legacy/build/pdf").then(
      (module) => module.default ?? module,
    );
  return library;
};

const sharedWorker = (pdfjs) => {
  if (isNil(worker) || worker.destroyed)
    worker = new pdfjs.PDFWorker({
      port: new Worker(
        new URL("pdfjs-dist/legacy/build/pdf.worker.js", import.meta.url),
      ),
    });
  return worker;
};

export const openPdf = (bytes) =>
  pdfLibrary().then((pdfjs) =>
    pdfjs.getDocument({
      data: bytes.slice(),
      isEvalSupported: false,
      worker: sharedWorker(pdfjs),
    }),
  );

export const pdfOperators = () => pdfLibrary().then((pdfjs) => pdfjs.OPS);

export const bytesOf = (base64) =>
  Uint8Array.from(atob(base64), (character) => character.charCodeAt(0));

export const saveBytes = ({
  bytes,
  fileName,
  contentType = PDF_CONTENT_TYPE,
}) => saveBlob({ content: bytes, fileName, contentType });
